/* eslint-disable no-unused-vars */
import { FiExternalLink } from "react-icons/fi";

export const WORKER_LOGTIME_ATTACHMENT_SIZE_ERROR_MSG =
  "ファイルサイズが上限を超えています。10MB以下のファイルを選択してください。";

export enum LOG_TYPE {
  CHECKIN = "check_in",
  CHECKOUT = "check_out",
  BREAK_START = "break_start",
  BREAK_END = "break_end",
  NOTE = "note",
  OTHER = "other",
}

export enum LOG_STATUS {
  BREAK = "break",
  WORK = "work",
  END = "end",
}

export const BUTTONS_ACTION = [
  {
    label: "出勤",
    log_type: LOG_TYPE.CHECKIN,
    style: {
      background: "#2B3864",
      height: 62,
      fontWeight: 700,
      fontSize: 24,
      color: "#fff",
    },
  },
  {
    label: "退勤",
    log_type: LOG_TYPE.CHECKOUT,
    style: {
      background: "#CE543D",
      height: 62,
      fontWeight: 700,
      fontSize: 24,
      color: "#fff",
    },
  },
  {
    label: "休憩開始",
    log_type: LOG_TYPE.BREAK_START,
    style: {
      height: 36,
      color: "#1E3666",
      fontWeight: 700,
      fontSize: 16,
      border: "1px solid #1E3666",
    },
  },
  {
    label: "休憩終了",
    log_type: LOG_TYPE.BREAK_END,
    style: {
      height: 36,
      color: "#CE543D",
      fontWeight: 700,
      fontSize: 16,
      border: "1px solid #CE543D",
    },
  },
  {
    label: "その他労務申請",
    log_type: LOG_TYPE.OTHER,
    icon: <FiExternalLink fontSize={18} />,
    style: {
      height: 32,
      background: "#545454",
      fontWeight: 500,
      fontSize: 14,
      color: "#fff",
    },
  },
];
